import * as React from 'react'
import { Popup } from '@/ui/overlays/Popup'
import { PopupStepUploading } from '@/modules/imports/ui/PopupStepUploading'
import { StepCommonPending } from './StepCommonPending'
import { getImportStepMessages, isPendingStep } from './config'
import { useImportFlow } from './useImportFlow'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { getProgressConfig } from './utils'
import { useImportsUploadingType } from '@/modules/imports/stores/importsUploadingTypeStore'
import { PopupStepSimpleImportSummary } from '../../ui/step-import-summary/PopupStepSimpleImportSummary'

type Props = {
  isOpen?: boolean
  handleClose?: () => void
  companyId: string
  onSuccess?: () => void
}

export const SimpleImportPopupContainer = ({
  isOpen,
  handleClose,
  companyId,
  onSuccess,
}: Props) => {
  const { t } = useLocalize()
  const IMPORT_STEP_MESSAGES = getImportStepMessages(t)

  const { uploadingType } =
      useImportsUploadingType()

  const {
    step,
    handleFinish,
    handleUploadFiles,
    handleRestart,
    handleAbortAndReset,
    uploadDetails,
    filesCount,
    uploadedFilesCount,
    logsCount,
  } = useImportFlow({
    handleClose,
    companyId,
    uploadingType,
    onSuccess,
  })

  const handleCloseOrCancel = () => {
    handleAbortAndReset()
    handleClose()
  }

  return (
    <>
      <Popup
        open={isOpen}
        onClose={handleCloseOrCancel}
        contentClassName="tw-min-w-[80vw]"
      >
        {isPendingStep(step) && (
          <StepCommonPending
            title={IMPORT_STEP_MESSAGES[step]?.title || ''}
            description={IMPORT_STEP_MESSAGES[step]?.description || ''}
            onAbort={handleCloseOrCancel}
            {...getProgressConfig({
              step,
              filesCount,
              uploadedFilesCount,
              logsCount,
            })}
          />
        )}
        {step === 'user:uploadFiles' && (
          <PopupStepUploading
            handleUpload={handleUploadFiles}
            isUploading={false}
          />
        )}
        {step === 'user:confirmSummary' && (
          <PopupStepSimpleImportSummary
            uploadDetails={uploadDetails}
            handleSubmit={handleFinish}
            handleClose={handleRestart}
          />
        )}
      </Popup>
    </>
  )
}
